module.exports = __webpack_public_path__ + "media/images/countrysquared/ye-79bc301c1709270b5362e32ac783a57c.svg";